<mat-card appearance="outlined" *ngIf="fetchingError">
  <mat-card-content class="row">
    <mat-icon class="no-flex">error</mat-icon>
    <span>Error when fetching configurations. Make sure the chargepoint is online and try again.</span>
  </mat-card-content>
</mat-card>


<div>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>

<mat-card appearance="outlined" *ngIf="!alreadyFetchedAtLeastOnce">
  <mat-card-content class="row">
    <mat-icon class="no-flex">info</mat-icon>
    <span>Configurations have not been fetched yet.</span>
  </mat-card-content>
</mat-card>

<ng-container *ngIf="expectedConfigurationErrors$ | async as expectedConfigurationErrors">
  <mat-card appearance="outlined" *ngIf="expectedConfigurationErrors.length > 0">
    <mat-card-header>
      <mat-icon color="warn"mat-card-avatar >error</mat-icon>
      <mat-card-title>Configuration does not match R+ standards</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      A few configurations does not match the expected configuration:
      <ul>
        <li *ngFor="let error of expectedConfigurationErrors">
          <div class="inline-flex">
            {{error}}
            <mat-icon *ngIf="expectedConfigurationErrorsFixStatus[error] === 'todo'" color="primary">pending_actions</mat-icon>
            <mat-spinner *ngIf="expectedConfigurationErrorsFixStatus[error] === 'pending'" color="primary" diameter="16"></mat-spinner>
            <mat-icon *ngIf="expectedConfigurationErrorsFixStatus[error] === 'success'" color="primary">check</mat-icon>
            <mat-icon *ngIf="expectedConfigurationErrorsFixStatus[error] === 'error'" color="warn">error</mat-icon>
          </div>
        </li>
      </ul>
      <ng-container *ngIf="rebootRequired">
        <mat-divider></mat-divider>
        <div class="inline-flex">
          <mat-icon color="warn">warning</mat-icon>
          <span>Reboot required to finalize configuration</span>
        </div>
      </ng-container>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button color="primary" (click)="applyAllExpectedConfiguration()" *ngIf="!rebootRequired">
        <mat-icon>check</mat-icon>
        <span>Apply expected configuration</span>
      </button>
      <button mat-button color="primary" (click)="reboot()" *ngIf="rebootRequired">
        <mat-icon>power_settings_new</mat-icon>
        <span>Reboot</span>
      </button>
    </mat-card-actions>
  </mat-card>
</ng-container>

<table mat-table *ngIf="configuration$ && (configuration$ | async) as configuration" [dataSource]="configuration" class="mat-elevation-z8">
  <ng-container matColumnDef="key">
    <th mat-header-cell *matHeaderCellDef>Key</th>
    <td mat-cell *matCellDef="let config">
      <div class="configuration-key" [class.error]="config.expectedConfigurationError">
        <mat-icon *ngIf="config.expectedConfigurationError" color="warn">error</mat-icon>
        <div class="info">
          {{config.key}}
          <span class="hint" *ngIf="config.expectedConfigurationError">
            Expected : {{config.expectedConfiguration}}
          </span>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>Value</th>
    <td mat-cell *matCellDef="let config">
      <mat-form-field subscriptSizing="dynamic" class="full-width">
        <input matInput [(ngModel)]="config.editableValue" [readonly]="config.readonly">
      </mat-form-field>
    </td>
  </ng-container>

  <ng-container matColumnDef="send">
    <th mat-header-cell *matHeaderCellDef>Send</th>
    <td mat-cell *matCellDef="let config">
      <button mat-icon-button color="primary" *ngIf="!config.readonly && config.expectedConfigurationError" matTooltip="Apply expected configuration" (click)="applyExpectedConfiguration(config)">
        <mat-icon>plumbing</mat-icon>
      </button>
      <button mat-icon-button color="primary" *ngIf="!config.readonly" [disabled]="config.editableValue === config.value" matTooltip="Update configuration" (click)="updateConfiguration(config)">
        <mat-icon>send</mat-icon>
      </button>
      <span *ngIf="config.readonly" class="readonly-indicator">
        <mat-icon inline="true">lock</mat-icon>
        Readonly
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['key', 'value', 'send']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['key', 'value', 'send'];"></tr>
</table>